import React from "react";
import styled from "styled-components";
import Navigation from "./Navigation";
import Lottie from "react-lottie";
import scroll from "../Animations/scrollDown.json";
import Rohit from "../Images/r_rohit.png";
// import RK_100 from "../Images/rohit_1.png";

import {
  // MainHeadingWrapper,
  ParagraphWrapper,
} from "../Elements/Elements";

const scrollOptions = {
  loop: true,
  autoplay: true,
  animationData: scroll,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor};
  background: url(${(props) => props.theme.header});
  background-repeat: no-repeat;
  background-size: cover;
`;

const Header = styled.div`
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HeaderContent = styled.div`
  z-index: 5;
  width: 90%;
  margin: 150px auto;
  max-width: 1200px;
  display: flex;
  /* margin: 0px auto; */
  justify-content: space-between;
  align-items: center;
  /* background-color: #03192c; */
  padding: 50px;
  > div {
    margin: 20px auto;
    width: fit-content;
    max-width: 800px;
    height: 30vh;
  }
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
    justify-content: center;
    margin: 50px auto;
    padding: 10px;
  }
  @media (max-width: 768px) {
    > div {
    }
  }
`;

const Heading = styled.div`
  width: 65%;
  min-width: 300px;
  text-align: left;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  justify-content: space-between;
  h1 {
    font-size: 60px;
    margin: 0;
  }
  @media (max-width: 1000px) {
    width: 100%;

    h1 {
      font-size: 40px;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
  }
`;

const ActionsDiv = styled.div`
  width: 60%;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  a {
    text-decoration: none;
  }
`;

const CTAButton = styled.div`
  min-width: fit-content;
  padding: 5px 10px;
  font-size: 19px;
  border-radius: 5px;
  border: 2px solid ${(props) => props.theme.secondary};
  color: ${(props) => (props.currentTheme === "light" ? "black" : "white")};
  font-weight: 500;
  background-color: ${(props) => props.theme.secondary};
  transition: all 500ms ease;
  cursor: pointer;
  :hover {
    background-color: ${(props) => props.theme.body};
    color: white;
  }
`;

const Profile = styled.div`
  width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  img {
    width: 70%;
    border-radius: 50%;
  }
  @media (max-width: 1000px) {
    img {
      width: 45%;
      border-radius: 50%;
    }
  }
`;

const Scroller = styled.div`
  margin: 0px auto;
  width: 100px;
  @media (max-width: 1000px) {
    /* display: none; */
    width: 50px;
  }
`;

function Head({ currentTheme, themeToggler }) {
  return (
    <Wrapper id="home">
      <Header>
        <Navigation
          currentTheme={currentTheme}
          themeToggler={themeToggler}
        ></Navigation>
        <HeaderContent>
          <Heading>
            <ParagraphWrapper>
              <p>ROHIT KUMAR</p>
            </ParagraphWrapper>
            <div>
              <h1>Full Stack Web Developer</h1>
            </div>
            <ParagraphWrapper>
              <p>
                Hi, its nice to meet you. I am a full stack developer residing
                in Patna, Bihar.
              </p>
            </ParagraphWrapper>
            <ActionsDiv>
              <a href="#projects">
                <CTAButton currentTheme={currentTheme}>View Projects</CTAButton>
              </a>
            </ActionsDiv>
            <ActionsDiv>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://drive.google.com/file/d/1OTFmDED68JoXtlnKn9DkWMsV-LG5GOoJ/view?usp=sharing"
                download
              >
                <CTAButton currentTheme={currentTheme}>
                  <span> Download Resume</span>
                </CTAButton>
              </a>
            </ActionsDiv>
            <div>
              <div title="Click here to call" style={{ display: "flex" }}>
                <div>
                  <a target="_blank" rel="noreferrer" href="tel:+918804713288">
                    {/* <i className="fas fa-phone-square-alt"></i> */}
                    <i className="fas fa-phone-alt"></i>
                  </a>
                </div>
                <div>
                  <a target="_blank" rel="noreferrer" href="tel:+918804713288">
                    <p>+91 8804713288 </p>
                  </a>
                </div>
              </div>
              <div title="Click here to mail" style={{ display: "flex" }}>
                <div>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="mailto:rohit9909mr@gmail.com"
                  >
                    {/* <i className="fas fa-envelope-square"></i> */}
                    <i className="fas fa-envelope"></i>
                  </a>
                </div>
                <div>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="mailto:rohit9909mr@gmail.com"
                  >
                    <p>rohit9909mr@gmail.com</p>
                  </a>
                </div>
              </div>
            </div>
          </Heading>
          <Profile>
            <img src={Rohit} alt="profile"></img>
          </Profile>
        </HeaderContent>
        <Scroller>
          <Lottie options={scrollOptions}></Lottie>
        </Scroller>
      </Header>
    </Wrapper>
  );
}

export default Head;
